// eslint-disable-next-line camelcase
export const link_activation_result_type1 = "link_activation_result_type1";
// export const glink_enterkey_enter_success = "glink_enterkey_enter_success";
